import React from 'react';
import Sprites from './Sprites';
import { Container } from './styles/GridAndListIcons.styled';

export default function ListIcon({ selected, setValue, type }) {
  const handleClick = () => {
    setValue('listpress');
  };
  return (
    <Container iconType={type} selected={selected} onClick={handleClick}>
      <Sprites name="list" />
    </Container>
  );
}
